import { render, staticRenderFns } from "./ReportsList.vue?vue&type=template&id=78cb150b&scoped=true&"
import script from "./ReportsList.vue?vue&type=script&lang=js&"
export * from "./ReportsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cb150b",
  null
  
)

export default component.exports